import React, { useEffect, useState } from "react";

import $ from "jquery";
import "jquery-scrollify";

import Pages from "./exports/Pages";
import NavigationIcons from "./exports/NavigationIcons";
import BubbleEffect from "./components/BubbleEffect";

import "./App.css";

const panelSections = [
  {
    name: "about",
    component: Pages.About,
    zIndex: "z-1",
    panelSection: "About",
    icon: NavigationIcons.Avatar,
  },
  {
    name: "skills",
    component: Pages.Skills,
    zIndex: "z-2",
    panelSection: "Skills",
    icon: NavigationIcons.Star,
  },
  {
    name: "projects",
    component: Pages.Projects,
    zIndex: "z-3",
    panelSection: "Projects",
    icon: NavigationIcons.CmdPrompt,
  },
  {
    name: "experience",
    component: Pages.WorkExperience,
    zIndex: "z-4",
    panelSection: "Experience",
    icon: NavigationIcons.Clock,
  },
  {
    name: "contact",
    component: Pages.Contact,
    zIndex: "z-5",
    panelSection: "Contact",
    icon: NavigationIcons.Conversation,
  },
];

function App() {
  const [activeSection, setActiveSection] = useState("about");

  useEffect(() => {
    const elements = {
      scrollify: $(".js--scrollify"),
      navigate: $(".js--navigate"),
      navigateItems: $(".js--navigate-items"),
      navigateLink: $(".js--navigate-link"),
      standardScrollElements: $(".js--no-scrollify"),
    };

    elements.navigateItems.on("click", ".js--navigate-link", (ev) => {
      ev.preventDefault();
      const $this = $(ev.currentTarget);
      const hash = $this.attr("href");
      $.scrollify.move(hash);
    });

    $.scrollify({
      section: ".js--scrollify",
      sectionName: "section-name",
      standardScrollElements: ".no-scrollify",
      overflowScroll: true,
      before(index, sections) {
        const ref = sections[index].data("section-name");
        setActiveSection(ref);
        elements.navigate.removeClass("is--inactive");
        elements.navigateLink
          .parent()
          .siblings()
          .find(".js--navigate-link")
          .removeClass("is--active");
        elements.navigateLink.eq(index).addClass("is--active");
      },
      afterRender() {
        $("body").css("overflow-x", "hidden");
      },
    });

    // Add an event listener to force the overflow-x: hidden behavior
    const handleScroll = () => {
      window.scrollTo(0, window.scrollY);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div
      style={{
        overflowX: "hidden !important",
      }}
    >
      <nav className="section-navigate js--navigate">
        <ul className="flex flex-col items-center section-navigate__items js--navigate-items">
          {panelSections.map((section, index) => {
            return (
              <li
                key={index}
                className={`${
                  activeSection !== section.panelSection.toLowerCase()
                    ? "section-navigate__item"
                    : ""
                }`}
              >
                <a
                  href={`#${section["panelSection"].toLowerCase()}`}
                  className={`section-navigate__link js--navigate-link is--active`}
                >
                  {activeSection === section.panelSection.toLowerCase() ? (
                    <BubbleEffect
                      isActive={
                        activeSection === section.panelSection.toLowerCase()
                      }
                      setActiveSection={setActiveSection}
                      label={section.panelSection}
                      icon={section.icon}
                    />
                  ) : (
                    <></>
                  )}
                </a>
              </li>
            );
          })}
        </ul>
      </nav>
      <div>
        {panelSections.map((section) => (
          <section
            key={section.name}
            className={`section__${section.name} is--scrolled js--scrollify ${section.zIndex} sticky top-0 fullHeight`}
            data-section-name={section.name}
          >
            <div className="absolute w-full h-full bg-black">
              <Pages.GalaxyAnimation />
            </div>
            <div
              className={`${
                section.name === "about" ? "absolute" : ""
              } top-0 left-0 p-4`}
            >
              <section.component />
            </div>
          </section>
        ))}
      </div>
    </div>
  );
}

export default App;
